import { createReducer, on } from '@ngrx/store';
import {
  SetOnboardingStatus,
  SetOnboardingLoading,
} from './onboarding.actions';

type StepStatus = 'WELCOME' | 'INFOEDIT' | 'REVIEW';

export interface OnboardingState {
  status: boolean;
  onboardingStep: StepStatus;
  loading: boolean;
}

export const initialOnboardingState: OnboardingState = {
  status: false,
  onboardingStep: 'WELCOME',
  loading: false,
};

export const onboardingReducer = createReducer(
  initialOnboardingState,

  on(SetOnboardingStatus, (state, { status, onboardingStep }) => {
    return {
      ...state,
      status,
      onboardingStep,
    };
  }),
  on(SetOnboardingLoading, (state, { loading }) => {
    return {
      ...state,
      loading,
    };
  })
);
